import loggerManager from '../../utils/log/logger-manager';

export default async function loadWorklet(context: AudioContext, content: string) {
  if (!context.audioWorklet) return Promise.reject('audioWorklet is not supported');
  try {
    await context.audioWorklet.addModule(content);
    loggerManager.info('worklet addModule success');
  } catch (err: any) {
    loggerManager.info(`worklet addModule catch error. ${err.message}`);
    throw err;
  }
}
